/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { AcatsBrokerageFirms } from '../../../shared/models/Enum/AcatsBrokerageFirms';

@Component({
  selector: 'ns-fund-by-broker-choose-firm',
  template: require('./fund-by-broker-choose-firm.component.html')
})

export class FundByBrokerChooseFirmComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.searchPlaceholder = 'Search for a broker';
    this.acatsNoResultsText = 'I don\'t see my broker';
    this.acatsNoResultsLink = '/fund-by-broker-info';
    this.appType = this.flowManager.getAppType();
    this.allFirms = AcatsBrokerageFirms;
    this.topFirms = this.allFirms.slice(0,9);
  }

  ngOnInit() {
    this.flowManager.resetAcatsFirm();
  }

  selectFirm(firmObj) {
    this.appActions.setData('Acats.acatsFirmName', firmObj.name);
    this.appActions.setData('Acats.acatsFirmDTC', firmObj.dtc);
    this.router.navigate(['/fund-by-broker-account']);
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  btnClick(e) {
    if (e.action === 'back') {
      this.router.navigate(['/fund-by-broker']);
    } else if (e.action === 'fund_later') {
      this.flowManager.fundLaterRouting();
    }
  }
}
